import {
  LEVEL_LIST,
  LEVEL_CREATE_SUCCESS,
  LEVEL_LIST_SUCCESS,
  LEVEL_INFO_SUCCESS,
  LEVEL_FILTER_HANDLING,
  LEVEL_SEARCH_NAME,
  LEVEL_UPDATE_SUCCESS,
  // LEVEL_LEVEL_SUCCESS,
  // LEVEL_LEVEL_CREATE_SUCCESS,
  // LEVEL_LEVEL_UPDATE_SUCCESS,
  CLEAR_LEVEL_INFO,
  // LEVEL_LEVEL_INFO,
  LEVEL_FILTER_SUCCESS,
} from "../actionTypes/level";

// import {
//   COLUMN_HANDLING,
//   _LEVEL_DATA,
//   _LEVEL_FILTER_DATA,
//   _LANGUAGE_DATA,
//   _MERCHANT_DATA,
// } from "../../_mocks_/coursetype";
// import { COLUMN_HANDLING } from "../../_mocks_/course";

const INIT_STATE = {
  // coursetypeFilters: _COURSETYPE_FILTER_DATA,
  levelList: [],
  isSuccess: false,
  levels: [],
  levelInfo: {},
  levels: [],
  levelInfo: {},
  queryInfo: {
    page: 1,
    size: 10,
    next: false,
  },
  totalRecords: 0,
  page: 1,
  pages: 0,
  // columnHandling: COLUMN_HANDLING,
  searchName: "",
  searchStatus: false,
  levelType: "Active",
  isUpdate: false,
  isLevel: true,
  isInfo: false,
  currentStep: 0,
  isEdit: false,
};

function levelReducer(state = INIT_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    // case PLATFORM_FILTER_SUCCESS: {
    //   console.log({ payload });
    //   return {
    //     ...state,
    //     // // platformFilters: { ..._PLATFORM_FILTER_DATA, ...payload },
    //   };
    // }
    // case PLATFORM_COURSETYPE_INFO: {
    //   return {
    //     ...state,
    //     coursetypeInfo: payload,
    //   };
    // }
    case CLEAR_LEVEL_INFO: {
      return {
        ...state,
        levelInfo: {},
      };
    }
    case LEVEL_LIST: {
      console.log({ payload });
      return {
        ...state,
        levels: payload,
      };
    }
    // case PLATFORM_COURSETYPE_SUCCESS: {
    //   console.log({ payload });
    //   return {
    //     ...state,
    //     coursetypes: payload,
    //     isCoursetype: false,
    //   };
    // }
    // case PLATFORM_COURSETYPE_CREATE_SUCCESS: {
    //   console.log({ payload });
    //   return {
    //     ...state,
    //     coursetypes: { payload, ...state.coursetypes },
    //     isCoursetype: false,
    //   };
    // }
    // case PLATFORM_COURSETYPE_UPDATE_SUCCESS: {
    //   var list = state.coursetypes.map((row) => (row._id === payload._id ? payload : row));
    //   // console.log({ payload, info });
    //   return {
    //     ...state,
    //     coursetypes: list.filter((row) => row.active),
    //     isCoursetype: false,
    //   };
    // }
    case LEVEL_LIST_SUCCESS: {
      return {
        ...state,
        searchStatus: false,
        levelList: payload.data,
        queryInfo: {
          ...payload.queryInfo,
        },
        totalRecords: payload.count,
        pages: payload.pages,
        isSuccess: false,
        isLevel: true,
        // page: payload.queryInfo.page || 0
      };
    }

    case LEVEL_CREATE_SUCCESS: {
      return {
        ...state,
        levelList: [payload, ...state.levelList],
        levelInfo: payload,
        currentStep: payload.currentStep + 1,
        isSuccess: true,
        isEdit: payload && payload._id ? true : false,
      };
    }

    case LEVEL_UPDATE_SUCCESS: {
      console.log({ payload });
      return {
        ...state,
        levelList: state.levelList.map(
          (obj) => (payload._id === obj._id ? payload : obj)
          // data.columnHandling.map((row) => obj.id === row)
        ),
        levelInfo: payload,
        currentStep: payload.currentStep + 1,
        isSuccess: true,
        isUpdate: true,
      };
    }

    case LEVEL_INFO_SUCCESS: {
      console.log({ payload });
      return {
        ...state,
        levelInfo: payload,
        isInfo: true,
        isEdit: true,
      };
    }
    case LEVEL_FILTER_HANDLING: {
      console.log({ payload });
      return {
        ...state,
        columnHandling: payload.columnHandling,
        levelType: payload.levelType,
      };
    }
    case LEVEL_SEARCH_NAME: {
      console.log({ payload });
      return {
        ...state,
        searchName: payload,
        searchStatus: true,
        queryInfo: { page: 1, size: state.queryInfo.size },
      };
    }

    default:
      return state;
  }
}

export default levelReducer;
